/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';

const MinusDelete = ({ handleClick }) => (
  <div className="btn-component-div">
    <button type="button" className="btn btn-link" onClick={handleClick}>
      <span className="glyphicon glyphicon-trash red" aria-hidden="true" />
    </button>
  </div>
);

MinusDelete.propTypes = {
  handleClick: PropTypes.func
};

export default MinusDelete;
